import React from "react";

const ShakeStyle = () => {
	return (<style>
		{`
				@keyframes shake {
					0% { transform: rotate(0deg); }
					25% { transform: rotate(5deg); }
					50% { transform: rotate(-5deg); }
					75% { transform: rotate(5deg); }
					100% { transform: rotate(0deg); }
				}
				@keyframes glow {
					from {filter: drop-shadow(0px 0px 8px rgba(0, 0, 0, 0.15)) }
					to { filter: drop-shadow(0px 0px 12px rgba(0, 0, 0, 1)) }
				}
				.can-group {
					transform-origin: bottom center;
					transition: filter 0.3s ease-in-out, transform 0.3s ease-in-out;
				}
			`}
	</style>)
}

export const SvgTropical = (props: {
	slotProps?: {
		svg?: React.SVGProps<SVGSVGElement>
	}
}) => {
	return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="-50 0 300 420" width="100%"
	             height="400px" {...props.slotProps?.svg}>
		<ShakeStyle/>
		<defs>
			<linearGradient id="canGradient" x1="0%" y1="0%" x2="100%" y2="0%">
				<stop offset="0%" stopColor="#EAA600"/>
				<stop offset="20%" stopColor="#FFCE00"/>
				<stop offset="80%" stopColor="#FFCE00"/>
				<stop offset="100%" stopColor="#EAA600"/>
			</linearGradient>
		</defs>

		<ellipse cx="100" cy="365" rx="50" ry="8" fill="rgba(0,0,0,0.15)"/>

		<g className="can-group">
			<rect x="40" y="45" width="120" height="310" rx="12" fill="url(#canGradient)"/>

			<ellipse cx="100" cy="45" rx="55" ry="10" fill="#D8D8D8"/>
			<ellipse cx="100" cy="43" rx="48" ry="7" fill="#EEEEEE"/>

			<path d="M40 343 Q100 365 160 343 L160 355 Q100 375 40 355 Z" fill="#D49A00" opacity="0.6"/>

			<text x="100" y="190" fontFamily="Georgia, 'Times New Roman', serif" fontSize="42" fontWeight="bold"
			      fill="#363636" textAnchor="middle" letterSpacing="1">BALY
			</text>

			<text x="100" y="235" fontFamily="'Brush Script MT', 'Pacifico', cursive" fontSize="28" fill="#4A4A4A"
			      textAnchor="middle" transform="rotate(-3, 100, 235)">Tropical
			</text>
		</g>
	</svg>)
}

export const SvgIntencion = (props: {
	slotProps?: {
		svg?: React.SVGProps<SVGSVGElement>
	}
}) => {
	return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 400" width="100%"
	             height="400px"  {...props.slotProps?.svg}>
			<ShakeStyle/>
			<defs>
				<linearGradient id="bottleGrad" x1="0%" y1="0%" x2="0%" y2="100%">
					<stop offset="0%" stop-color="#0a1b4d"/>
					<stop offset="25%" stop-color="#1b458f"/>
					<stop offset="50%" stop-color="#ffffff"/>
					<stop offset="100%" stop-color="#e8e8e8"/>
				</linearGradient>

				<linearGradient id="capGrad" x1="0%" y1="0%" x2="100%" y2="0%">
					<stop offset="0%" stop-color="#888888"/>
					<stop offset="50%" stop-color="#cccccc"/>
					<stop offset="100%" stop-color="#666666"/>
				</linearGradient>

				<polygon id="star" points="0,-4 1.2,-1.2 4,-1.2 2,0.8 2.8,4 0,2.4 -2.8,4 -2,0.8 -4,-1.2 -1.2,-1.2"/>
			</defs>
			<g className="can-group">
				<ellipse cx="100" cy="385" rx="45" ry="5" fill="rgba(0,0,0,0.12)"/>

				<path d="M 88 50
           C 88 80, 55 100, 55 140
           L 55 375
           Q 100 395, 145 375
           L 145 140
           C 145 100, 112 80, 112 50
           Z" fill="url(#bottleGrad)"/>

				<path d="M 55 160 L 75 120 L 95 145 L 115 100 L 135 140 L 145 130 L 145 190 L 55 190 Z" fill="#ffffff"
				      opacity="0.2"/>

				<rect x="86" y="10" width="28" height="35" rx="2" fill="url(#capGrad)"/>
				<rect x="86" y="18" width="28" height="2" fill="#555" opacity="0.3"/>
				<rect x="86" y="26" width="28" height="2" fill="#555" opacity="0.3"/>
				<rect x="86" y="34" width="28" height="2" fill="#555" opacity="0.3"/>

				<text x="100" y="260" font-family="Georgia, serif" font-size="16" font-weight="bold" fill="#0a1b4d"
				      text-anchor="middle" letter-spacing="1">INTENCION
				</text>

				<use href="#star" x="65" y="280" fill="#0a1b4d" transform="rotate(-15, 65, 280)"/>
				<use href="#star" x="82.5" y="286" fill="#0a1b4d" transform="rotate(-7, 82.5, 286)"/>
				<use href="#star" x="100" y="288" fill="#0a1b4d"/>
				<use href="#star" x="117.5" y="286" fill="#0a1b4d" transform="rotate(7, 117.5, 286)"/>
				<use href="#star" x="135" y="280" fill="#0a1b4d" transform="rotate(15, 135, 280)"/>
			</g>
		</svg>
	)
}

export const SvgIntencionDbBlack = (props: {
	slotProps?: {
		svg?: React.SVGProps<SVGSVGElement>
	}
}) => {
	return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 400" width="100%"
	             height="400px" {...props.slotProps?.svg}>
			<ShakeStyle/>
			<defs>
				<linearGradient id="capGrad" x1="0%" y1="0%" x2="100%" y2="0%">
					<stop offset="0%" stop-color="#aaaaaa"/>
					<stop offset="50%" stop-color="#eeeeee"/>
					<stop offset="100%" stop-color="#888888"/>
				</linearGradient>

				<linearGradient id="silverText" x1="0%" y1="0%" x2="0%" y2="100%">
					<stop offset="0%" stop-color="#ffffff"/>
					<stop offset="100%" stop-color="#999999"/>
				</linearGradient>
			</defs>

			<g className={'can-group'}>
				<ellipse cx="100" cy="380" rx="60" ry="7" fill="rgba(0,0,0,0.3)"/>

				<path d="M 85 50
           L 85 75
           C 85 90, 35 95, 35 120
           L 35 365
           Q 100 380, 165 365
           L 165 120
           C 165 95, 115 90, 115 75
           L 115 50
           Z" fill="#181818"/>
				<rect x="83" y="12" width="34" height="38" rx="2" fill="url(#capGrad)"/>
				<line x1="83" y1="22" x2="117" y2="22" stroke="#666" stroke-width="1.5"/>
				<line x1="83" y1="32" x2="117" y2="32" stroke="#666" stroke-width="1.5"/>
				<line x1="83" y1="42" x2="117" y2="42" stroke="#666" stroke-width="1.5"/>

				<g text-anchor="middle" fill="url(#silverText)">
					<text x="100" y="160" font-family="Georgia, serif" font-size="22" font-weight="normal">Intencion
					</text>

					<text x="100" y="210" font-family="Arial Black, Impact, sans-serif" font-size="35"
					      font-weight="bold"
					      opacity="0.35">50%
					</text>

					<text x="100" y="250" font-family="Arial Black, Impact, sans-serif" font-size="30"
					      letter-spacing="1">DOUBLE
					</text>
					<text x="100" y="295" font-family="Arial Black, Impact, sans-serif" font-size="30"
					      letter-spacing="4">BLACK
					</text>
				</g>
			</g>
		</svg>
	)
}

export const SvgMasterGold = (props: {
	slotProps?: {
		svg?: React.SVGProps<SVGSVGElement>
	}
}) => {
	return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 400" width="100%" height="400px" {...props.slotProps?.svg}>
			<ShakeStyle/>
			<defs>
				<linearGradient id="liquidGrad" x1="0%" y1="0%" x2="100%" y2="0%">
					<stop offset="0%" stop-color="#C5832B"/>
					<stop offset="50%" stop-color="#EAA64A"/>
					<stop offset="100%" stop-color="#A56417"/>
				</linearGradient>

				<linearGradient id="goldText" x1="0%" y1="0%" x2="100%" y2="0%">
					<stop offset="0%" stop-color="#D4AF37"/>
					<stop offset="50%" stop-color="#FFF2CD"/>
					<stop offset="100%" stop-color="#AA8015"/>
				</linearGradient>
			</defs>
			<g className={'can-group'}>

				<ellipse cx="100" cy="365" rx="45" ry="5" fill="rgba(0,0,0,0.2)"/>

				<path d="M 85 80
           L 85 100
           L 60 120
           L 60 360
           Q 100 365, 140 360
           L 140 120
           L 115 100
           L 115 80
           Z" fill="url(#liquidGrad)"/>

				<rect x="83" y="30" width="34" height="50" rx="2" fill="#151515"/>

				<rect x="83" y="75" width="34" height="4" fill="url(#goldText)"/>

				<line x1="83" y1="40" x2="117" y2="40" stroke="#2a2a2a" stroke-width="1.5"/>
				<line x1="83" y1="50" x2="117" y2="50" stroke="#2a2a2a" stroke-width="1.5"/>

				<rect x="65" y="150" width="70" height="100" rx="2" fill="#111111"/>

				<rect x="68" y="153" width="64" height="94" fill="none" stroke="url(#goldText)" stroke-width="1"
				      opacity="0.8"/>

				<g text-anchor="middle" fill="url(#goldText)">
					<path d="M 93 170 L 95 165 L 100 168 L 105 165 L 107 170 Z" fill="url(#goldText)"/>

					<text x="100" y="195" font-family="Georgia, serif" font-size="15" font-weight="bold"
					      letter-spacing="1">MASTER
					</text>
					<text x="100" y="215" font-family="Georgia, serif" font-size="15" font-weight="bold"
					      letter-spacing="1">GOLD
					</text>
				</g>
			</g>
		</svg>
	)
}